import { Button, Input, Modal, Select } from 'antd'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify'

import Loader from '../../../pages/pages/loader'
import { getUserId } from '../../../helpers/auth'
import { useAddCustomerChannelsMutation, useUpdateCustomerChannelsMutation } from '../../../redux/apis/customersManagement/channels/cMChannelsApiSlice'


const EditCreateChannel = ({ state, open, setOpen, record, customerId =null }) => {
  const [
    updateChannel,
    { isLoading: isUpdating, isSuccess: SuccessUpdate, error: errorUpdate }
  ] = useUpdateCustomerChannelsMutation()
  const [
    addChannel,
    { isLoading: isAdding, isSuccess: SuccessAdd, error: errorAdd }
  ] = useAddCustomerChannelsMutation()

  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      channel_name: record?.channel_name || '',
      channel_status: state === 'edit' ? record?.channel_status : true,
      video_wm_duration: record?.video_wm_duration || '',
      customer: customerId,
      last_updated_by: getUserId()
    },

    validationSchema: Yup.object({
      channel_name: Yup.string().required('Please Enter Channel Name'),
      channel_status: Yup.boolean().required('Please Enter Channel Status'),
      video_wm_duration: Yup.string().nullable()
    }),
    onSubmit: async values => {
      const formData = new FormData()
      for (let key in values) {
        formData.append(key, values[key])
      }

      try {
        if (state === 'edit') {
          await updateChannel({
            serviceData: formData,
            id: record?.id
          }).unwrap()
        } else if (state === 'create') {
          await addChannel({
            serviceData: formData,
          }).unwrap()
        }
      } catch (err) {
        console.error(err)
      }
    }
  })

  useEffect(() => {
    if (errorAdd?.data) {
      const errorMessages = Object.values(errorAdd.data).flat()
      errorMessages.forEach(message => {
        toast.error(message)
      })
    } else if (errorUpdate?.data) {
      const errorMessages = Object.values(errorUpdate.data).flat()
      errorMessages.forEach(message => {
        toast.error(message)
      })
    }
  }, [errorAdd, errorUpdate])

  useEffect(() => {
    if (SuccessAdd && state === 'create') {
      toast.success('Channel created successfully!')
      setOpen(false)
    } else if (SuccessUpdate && state === 'edit') {
      toast.success('Channel updated successfully!')
      setOpen(false)
    }
  }, [state, SuccessAdd, SuccessUpdate])
  
  return (
    <Modal
      className='customModal'
      open={open}
      title={
        state === 'edit' ? `Edit ${record?.channel_name}` : 'Create Channel'
      }
      onCancel={() => setOpen(false)}
      footer={[
        <Button key='back' onClick={() => setOpen(false)}>
          Cancel
        </Button>,
        <Button
          key='submit'
          type='primary'
          onClick={() => {
            if (Object.keys(validation.errors).length !== 0) {
              Object.keys(validation.errors).map(key => {
                toast.error(validation.errors[key])
              })
              return
            }
            validation.handleSubmit()
          }}
        >
          Submit
        </Button>
      ]}
    >
      <Loader isLoading={isAdding || isUpdating} />
      <div className=' mb-3'>
        <label className="form-label">Channel Name</label>
        <Input
          type='text'
          name='channel_name'
          onChange={validation.handleChange}
          onBlur={validation.handleBlur}
          value={validation.values.channel_name}
        />
        {validation.touched.channel_name && validation.errors.channel_name ? (
          <p className='text-danger'>{validation.errors.channel_name}</p>
        ) : null}
      </div>

      <div className=' mb-3'>
        <label className="form-label">Channel Status</label>
        <br />
        <Select
          name='channel_status'
          style={{
            width: '100%'
          }}
          value={validation.values.channel_status}
          onChange={e => validation.setFieldValue('channel_status', e)}
          onBlur={validation.handleBlur}
          options={[
            { label: 'Active', value: true },
            { label: 'InActive', value: false }
          ]}
        />
      </div>
      <div className=' mb-3'>
        <label className="form-label">Video Watermark Duration</label>
        <Input
          type='text'
          name='video_wm_duration'
          onChange={validation.handleChange}
          onBlur={validation.handleBlur}
          value={validation.values.video_wm_duration}
        />
        {validation.touched.video_wm_duration &&
        validation.errors.video_wm_duration ? (
          <p className='text-danger'>{validation.errors.video_wm_duration}</p>
        ) : null}
      </div>
    </Modal>
  )
}

export default EditCreateChannel
